import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { VenuesProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const VenuesList = Loader(lazy(() => import('../../content/pages/Venues/VenuesList')));
const CreateVenue = Loader(lazy(() => import('../../content/pages/Venues/VenueCreate')));
const VenueUpdate = Loader(lazy(() => import('../../content/pages/Venues/VenueUpdate')));
const VenueDetails = Loader(lazy(() => import('../../content/pages/Venues/VenueDetails')));

export const createVenuesRoutes = (groupRequired?: null | string, roleRequired?: null | string[]) => ({
  path: 'venues',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['venueViewAll', 'venueViewAllClient', 'venueViewAllVenue']} should404>
          <Navigate to="/venues/list" replace />
        </PermissionsGuard>
      )
    },
    {
      path: `:venueId/`,
      element: (
        <PermissionsGuard allowedPermissions={['venueViewAll', 'venueViewAllClient', 'venueViewAllVenue']} should404>
          <VenuesProvider>
            <VenueDetails />
          </VenuesProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'list',
      element: (
        <PermissionsGuard allowedPermissions={['venueViewAll', 'venueViewAllClient', 'venueViewAllVenue']} should404>
          <VenuesProvider>
            <VenuesList />
          </VenuesProvider>
        </PermissionsGuard>
      )
    },
    {
      path: `:venueId/update`,
      element: (
        <PermissionsGuard allowedPermissions={['venueUpdate']} should404>
          <VenuesProvider>
            <VenueUpdate />
          </VenuesProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'create',
      element: (
        <PermissionsGuard allowedPermissions={['venueCreate']} should404>
          <VenuesProvider>
            <CreateVenue />
          </VenuesProvider>
        </PermissionsGuard>
      )
    }
  ]
});
